import { memo, type FC } from 'react';

import Icons from '../../../Elements/Icons/index.ts';
import { DragHandle } from './DragHandle.tsx';
import type { DndRowDragProps } from './types.ts';

export type DragCellProps = Partial<DndRowDragProps>;

export const DragCell: FC<DragCellProps> = memo(function DragCell({ dragHandleRef }) {
  if (dragHandleRef) {
    return (
      <DragHandle ref={dragHandleRef}>
        <Icons.Drag size={20} />
      </DragHandle>
    );
  }

  return <Icons.Drag size={20} aria-hidden='true' />;
});
